<script lang="ts" setup>
import type { NuxtError } from '#app'

defineProps({
  error: {
    required: true,
    type: Object as PropType<NuxtError>,
  },
})

const { t } = useI18n()

useSeoMeta({
  description: t('description'),
  title: t('title'),
})
</script>

<template>
  <UMain>
    <UContainer>
      <UPage>
        <UPageError :error="error" />
      </UPage>
    </UContainer>
  </UMain>

  <LayoutGlobals />
</template>

<i18n lang="json">
{
  "en": {
    "description": "We are sorry but this page could not be found.",
    "title": "Page not found"
  },
  "es": {
    "description": "Lo sentimos, pero esta página no se puede encontrar.",
    "title": "Página no encontrada"
  },
  "fr": {
    "description": "Nous sommes désolés mais cette page est introuvable.",
    "title": "Page non trouvée"
  }
}
</i18n>
